import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { apiUrl } from '../services/http/http';
import ActiveRequestsService from '../services/active-requests/active-requests';
import CompetencyService from '../services/competency/competency';

class AttributeMap extends React.Component {
  activeRequests = new ActiveRequestsService();
  competencyService = new CompetencyService();

  constructor(props) {
    super(props);
    const pathParts = this.props.location.pathname.split('/');
    this.state = {
      data: [],
      framework: pathParts[4].replace(/ /g, ''),
      framework_id: '',
      resourceID: pathParts[2],
      frameworkdetails: [],
      csrf: '',
      selectedAttributes: [],
      selectedCompetencies: [],
      resourceDetails: ''
    };
  }

  handleSelect = async () => {
    const { selectedAttributes, framework_id, resourceID } = this.state;

    try {
      this.activeRequests.startRequest();

      await this.competencyService.attrmap(
        resourceID,
        selectedAttributes,
        framework_id
      );

      this.props.history.push(
        `/training-resources/${this.state.resourceDetails.slug}`
      );
    } catch (error) {
      this.setState({ loadingError: true });
    } finally {
      this.activeRequests.finishRequest();
    }
  };

  handleCompetencyToggle = (competencyId, isChecked, attributes) => {
    this.setState(prev => {
      let selectedCompetencies = [...prev.selectedCompetencies];
      let selectedAttributes = [...prev.selectedAttributes];

      if (isChecked) {
        if (!selectedCompetencies.includes(competencyId)) {
          selectedCompetencies.push(competencyId);
        }
        attributes.forEach(attr => {
          if (!selectedAttributes.includes(attr.id)) {
            selectedAttributes.push(attr.id);
          }
        });
      } else {
        selectedCompetencies = selectedCompetencies.filter(
          id => id !== competencyId
        );
        selectedAttributes = selectedAttributes.filter(
          id => !attributes.some(attr => attr.id === id)
        );
      }

      return { selectedCompetencies, selectedAttributes };
    });
  };

  handleAttributeToggle = (attributeId, isChecked) => {
    this.setState(prev => {
      let selectedAttributes = [...prev.selectedAttributes];
      if (isChecked) {
        if (!selectedAttributes.includes(attributeId)) {
          selectedAttributes.push(attributeId);
        }
      } else {
        selectedAttributes = selectedAttributes.filter(
          id => id !== attributeId
        );
      }
      return { selectedAttributes };
    });
  };

  async componentDidMount() {
    const { resourceID, framework } = this.state;

    // Fetch resource details
    const res = await fetch(
      `${apiUrl}/api/resources/?_format=hal_json&id=${resourceID}&timestamp=${Date.now()}`
    );
    const resourceDetails = await res.json();
    this.setState({ resourceDetails });

    // Preload selected attributes
    const preselectedAttributes = [];
    const preselectedCompetencies = [];

    if (resourceDetails.competency_profile) {
      resourceDetails.competency_profile.forEach(profile => {
        profile.domains.forEach(domain => {
          domain.competencies.forEach(comp => {
            preselectedCompetencies.push(comp.id);
            comp.attributes.forEach(attr => {
              preselectedAttributes.push(attr.id);
            });
          });
        });
      });
    }

    this.setState({
      selectedAttributes: preselectedAttributes,
      selectedCompetencies: preselectedCompetencies
    });

    // Fetch CSRF token
    const tokenRes = await fetch(`${apiUrl}/session/token`);
    const csrf = await tokenRes.text();
    this.setState({ csrf });

    // Fetch framework details
    const fwRes = await fetch(
      `${apiUrl}/api/version_manager?_format=json&timestamp=${Date.now()}`
    );
    const frameworkdetails = await fwRes.json();
    this.setState({ frameworkdetails });

    // Find latest live version
    let latest_version = '';
    let framework_id = '';
    frameworkdetails.forEach(detail => {
      if (detail.title.toLowerCase().replace(/ /g, '') === framework) {
        detail.versions.forEach(version => {
          if (version.status === 'live') {
            latest_version = version.number;
            framework_id = detail.nid;
          }
        });
      }
    });

    this.setState({ framework_id });

    // Fetch competencies
    const compRes = await fetch(
      `${apiUrl}/api/${framework}/${latest_version}?_format=json`
    );
    const data = await compRes.json();
    this.setState({ data });
  }

  render() {
    const {
      frameworkdetails,
      framework,
      data,
      resourceDetails,
      selectedCompetencies,
      selectedAttributes
    } = this.state;

    // Collect attribute types for grouping
    const attributeTypes = [];
    frameworkdetails.forEach(detail => {
      if (detail.title.toLowerCase().replace(/ /g, '') === framework) {
        detail.attribute_types.forEach(attrType => {
          attributeTypes.push(attrType.title);
        });
      }
    });

    return (
      <div>
        <h2>{resourceDetails.title}</h2>
        <h4>Type: {resourceDetails.type}</h4>
        <h4>URL: {resourceDetails.url}</h4>

        <table className="table">
          {data.flatMap((item, idx) => {
            const domains = item.core_domains?.length
              ? [...item.core_domains, ...item.domains]
              : item.domains;

            return domains.map((domain, did) => (
              <tbody key={`${idx}-${did}`}>
                <tr>
                  <td>{did + 1}</td>
                  <td>
                    <strong>{domain.title}</strong>
                  </td>
                </tr>

                {domain.competencies.map((competency, cid) => (
                  <tr key={competency.id}>
                    <td>
                      {did + 1}.{cid + 1}
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedCompetencies.includes(competency.id)}
                        onChange={e =>
                          this.handleCompetencyToggle(
                            competency.id,
                            e.target.checked,
                            competency.attributes
                          )
                        }
                      />{' '}
                      {competency.title}
                      <ul style={{ marginLeft: '1em', marginBottom: '1em' }}>
                        {attributeTypes.map((def, key) => (
                          <div style={{ marginLeft: '1em' }} key={key}>
                            <div>
                              <strong>
                                <em>{def}</em>
                              </strong>
                            </div>
                            {competency.attributes
                              .filter(attr => attr.type === def)
                              .map(attr => (
                                <li key={attr.id} style={{ marginLeft: '1em' }}>
                                  <input
                                    type="checkbox"
                                    checked={selectedAttributes.includes(
                                      attr.id
                                    )}
                                    onChange={e =>
                                      this.handleAttributeToggle(
                                        attr.id,
                                        e.target.checked
                                      )
                                    }
                                  />{' '}
                                  <span className={attr.archived}>
                                    {attr.title}
                                  </span>
                                </li>
                              ))}
                          </div>
                        ))}
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            ));
          })}
        </table>

        <div id="footer-button">
          <button
            className="vf-button vf-button--primary vf-button--sm"
            onClick={this.handleSelect}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}

const AttrMap = () => (
  <Switch>
    <Route
      exact
      path="/training-resources/:id/map/:framework"
      component={AttributeMap}
    />
  </Switch>
);

export default AttrMap;
